import { render } from "./CapsulaInfo.vue?vue&type=template&id=0bd5a455&scoped=true"
import script from "./CapsulaInfo.vue?vue&type=script&lang=js"
export * from "./CapsulaInfo.vue?vue&type=script&lang=js"

import "./CapsulaInfo.vue?vue&type=style&index=0&id=0bd5a455&scoped=true&lang=css"

import exportComponent from "/tmp/build_642e477e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd5a455"]])

export default __exports__